import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from 'prop-types';
import {updateSettings} from '../../routers/settings'
import localStorage from 'store';
import qs from 'qs';


import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';


class firstheader extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      open: false,
      token: undefined,
    };
  }

  componentDidMount() {
    // look for token from GET param, save it to local storage & remove from visible url
    const getParams = qs.parse(window.location.search.substring(1));
    if (getParams.token) {
      localStorage.set('token', getParams.token);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    // load token from local storage
    const token = localStorage.get('token');
    this.setState({ token });
  }

  handleUpdate = (key) => {
    this.props.updateSettings({defaultlanguage: key})
    this.handleRequestClose()
    this.context.router.history.push(`/${key}`)
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  logOut = () => {
    this.setState({
      token: undefined
    });
    localStorage.remove('token');
  }; 


  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const languages = this.props.settings.languages
    const keys = Object.keys(languages)
    const key = ( keys.indexOf(langUrl) === -1 ) ? 'es': langUrl

    const title = languages[key].title

    return (
      <div>
        {(() => {
          if (this.state.token) {
            return (
              <div id="port-mode">
                <div className="row">
                  <div className="container">
                    <div className="contents">
                      <div className="port-mode"> Modo puerto </div>
                      <div id="logOutButton">
                        <RaisedButton
                        onClick={this.logOut}
                        id="logOut"
                        label="Log Out"
                        primary={true}>
                        </RaisedButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        })()}

        <div className="container-fluid first-header">

          <div className="row">
            <div className="container">
              <div className="flex-row">
                <div className="flex-item regular">
                  <span className="white-link-container"><i className="fa fa-envelope" aria-hidden="true"></i>
                    <a href="mailto:pasajes@romeuycia.com">pasajes@romeuycia.com</a>
                  </span>
                </div>
                <div className="flex-item">
                  <i className="fa fa-phone" aria-hidden="true"></i>
                  +34 965 14 70 10
                </div>
                <div className="flex-item">
                  <div className="dropdown">
                    <div className="dropbtn" onClick={this.handleClick}>{title} <i className="fa fa-chevron-down" aria-hidden="true"></i></div>
                      <Popover
                        open={this.state.open}
                        anchorEl={this.state.anchorEl}
                        anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
                        targetOrigin={{horizontal: 'left', vertical: 'top'}}
                        onRequestClose={this.handleRequestClose}
                      >
                        <Menu>
                          {keys.map((key, index) => <MenuItem key={index} primaryText={languages[key].title} onClick={() => this.handleUpdate(key)}/>)}
                        </Menu>
                      </Popover>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings}),
  {updateSettings}
)(firstheader)



// WEBPACK FOOTER //
// ./src/shared/routes/components/firstHeader.js